import '../HomePage/Quotes.css';
import { CommaSeprator } from './UtilityComponents/UilityFunctions';



const BuyNowBtn = ({ netPremium, BuyNow }) => {

    
    return (
        <>
            <button className='' onClick={BuyNow} >
                {/*<small>Buy Now</small>*/}
                <p className="mb-0">₹{CommaSeprator(Math.round(netPremium))}<span>/yr</span></p>
            </button>
        </>
    );

}
export default BuyNowBtn;